import { CERCA, INTERMEDIO, LEJOS } from '../../modules/pel/constants/graduacion';
import {
  CLEAR_LENTES_LIST_ACTION,
  LENTES_PEL_CAMBIAR_PANEL_ACTIVO,
  LENTES_PEL_CLEAR_TOOLBAR_DATA, LENTES_PEL_ESTABLECER_DNP_OBLIGATORIO,
  LENTES_PEL_FORMULARIO_FILTRO_ESTABLECER_OPCIONES_PANEL,
  LENTES_PEL_GET_COLORES_LENTE_SUCCESS,
  LENTES_PEL_GET_COLORES_SUCCESS,
  LENTES_PEL_GET_DIAMETROS_POSIBLES_SUCCESS,
  LENTES_PEL_GET_FABRICANTES_SUCCESS,
  LENTES_PEL_GET_INDICES_SUCCESS,
  LENTES_PEL_GET_LENTES_LIST_SUCCESS,
  LENTES_PEL_GET_LENTESTIPOSPVP_SUCCESS,
  LENTES_PEL_GET_ORDEN_GRADUACION_SUCCESS,
  LENTES_PEL_GET_PASILLOS_SUCCESS, LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_SUCCESS,
  LENTES_PEL_MIS_CATALOGOS_MODIFICAR,
  LENTES_PEL_RESTABLECER_FILTRO,
  LENTES_PEL_SELECCION_COLOR,
  LENTES_PEL_SELECCION_COLOR_INTENSIDAD,
  LENTES_PEL_SELECCION_DIAMETRO,
  LENTES_PEL_SELECCION_FABRICANTE,
  LENTES_PEL_SELECCION_GRADUACION,
  LENTES_PEL_SELECCION_GRADUACION_GENERICA,
  LENTES_PEL_SELECCION_INDICE,
  LENTES_PEL_SELECCION_LENTE,
  LENTES_PEL_SELECCION_LENTE_TIPO_PVP,
  LENTES_PEL_SELECCION_PASILLO,
  LENTES_PEL_SELECCION_TRATAMIENTO_LENTE,
  LENTES_PEL_SELECCIONAR_CARACTERISTICA_FILTRO,
  LENTES_PEL_SET_ALTURA_FOCAL,
  LENTES_PEL_SET_DIAMETRO_MINIMO,
  LENTES_PEL_SET_FINAL_SELECTION, LENTES_PEL_SET_FUERA_NORMA,
  LENTES_PEL_SET_INICIALIZADO,
  LENTES_PEL_SET_MODO,
  LENTES_PEL_SET_SEARCH_VALUE,
  LENTES_PEL_SET_VIENE_DE, NEXT_PAGE_LENTES_LIST,
  SET_ERROR_SELECCION_LENTE,
} from '../actions/constants/pel.constants';

const initialState = {
  misCatalogos: {
    focos: [],
    categorias: [],
    colores: [],
    grosores: [],
  },
  filtrador: {
    panelActivo: 'catalogo',
    inputFocused: null,
    cambiarAutomaticamentePanel: false,
    busquedaValida: false,
    faltanDatosMontura: true,
    botonBusquedaEnabled: false,
    parametrosMonturaEsablecidos: false,
    fueraDeNorma: false,
    barraBusqueda: { value: null },
    pagina: 1,
    formulario: {
      catalogo: {
        nombre: 'Catalogo',
        id: 'catalogo',
        opciones: [],
        required: true,
        multiselect: false,
        disabled: false,
        limpiarFormularioTrasEditar: true,
        numeroDeFotos: 2,
      },
      focos: {
        nombre: 'Distancia',
        id: 'focos',
        opciones: [],
        required: true,
        disabled: true,
        limpiarFormularioTrasEditar: true,
      },
      categorias: {
        nombre: 'Categorías',
        id: 'categorias',
        required: true,
        limpiarFormularioTrasEditar: true,
        disabled: true,
        opciones: [],
        numeroDeFotos: 4,
      },
      tratamientos: {
        nombre: 'Tratamientos',
        id: 'tratamientos',
        required: false,
        limpiarFormularioTrasEditar: true,
        disabled: true,
        multiselect: false,
        opciones: [],
        numeroDeFotos: 5,
      },
      colores: {
        nombre: 'Color',
        id: 'colores',
        required: true,
        disabled: true,
        opciones: [],
      },
      grosores: {
        nombre: 'Índice de refreacción',
        id: 'grosores',
        multiselect: true,
        disabled: true,
        opciones: [],
      },
    },
    buscador: {
      misFabricantes: [],
      lentesTiposPvps: [],
      misColores: [],
    },
    selecciones: {
      montura: {
        id: null,
        descripcion: null,
        valor: null,
        tipoMontura: null,
        puente: null,
        calibre: null,
        precargada: false,
        diametroMinimo: 1,
        tieneFormaOma: false,
      },
      ordenGraduacion: null,
      graduacion: {
        precargada: false,
        valor: null,
        derecho: {
          ojo: null,
          ESFL: null,
          ESFC: null,
          CILL: null,
          CILC: null,
          AXISL: null,
          AXISC: null,
          ADD: null,
          DNPL: null,
          AVSC: null,
          AVCC: null,
          isSelected: false,
        },
        izquierdo: {
          ojo: null,
          ESFL: null,
          ESFC: null,
          CILL: null,
          CILC: null,
          AXISL: null,
          AXISC: null,
          ADD: null,
          DNPL: null,
          AVSC: null,
          AVCC: null,
          isSelected: false,
        },
        generico: {
          ESF: null,
          CIL: null,
          AXIS: null,
          ADD: null,
          DNPL: null,
          isSelected: false,
        },
      },
      lenteTipoPvp: null,
      grosores: [],
      indices: [],
      colores: null,
      miFabricante: null,
      miColor: null,
      pasillos: [],
    },
    lentes: {},
    datosLenteSeleccionada: {},
    errorSeleccion: null,
  },
  modo: 'consulta',
  packId: -1,
  numPack: -1,
  linea: -1,
  modoNoPel: false,
  usaMiCatalogo: true,
  paraLentesGenericas: true,
  puedeElegirCatalogo: false,
  dnpObligatorio: false,
  tienePromocion: false,
  packPromocional: null,
  viene_de: 'encargo',
  inicializado: false,
};


export default function pelReducer(state = initialState, { type, payload }) {
  switch (type) {
    case LENTES_PEL_SET_MODO: {
      const {
        modo, usaMiCatalogo, numPack, tienePromocion, puedeElegirCatalogo, paraLentesGenericas, linea, packId, packPromocional,
      } = payload;
      return {
        ...initialState, modo, usaMiCatalogo, numPack, tienePromocion, packPromocional, puedeElegirCatalogo, paraLentesGenericas, linea, packId,
      };
    }
    case LENTES_PEL_SET_VIENE_DE: {
      const { viene_de } = payload;
      return { ...state, viene_de };
    }
    case SET_ERROR_SELECCION_LENTE: {
      return { ...state, filtrador: { ...state.filtrador, errorSeleccion: payload } };
    }
    case LENTES_PEL_SELECCIONAR_CARACTERISTICA_FILTRO: {
      const { caracteristica, valorSeleccionado, permisos } = payload;
      const { id: idCaracteristica, multiselect } = caracteristica;
      const {
        misCatalogos, filtrador, filtrador: { formulario, selecciones }, viene_de, usaMiCatalogo, modo, tienePromocion, puedeElegirCatalogo, paraLentesGenericas,
      } = state;
      const {
        colores: coloresMisCatalogos,
        categorias: categoriasMisCatalogos,
        grosores: grosoresMisCatalogos,
        tratamientos: tratamientosMiCatalogo,
      } = misCatalogos;
      const {
        catalogo,
      } = selecciones;
      const seleccionesModificadas = {
        ...selecciones,
      };
      const formularioModificado = {
        ...formulario,
      };

      if (valorSeleccionado) {
        const { valor } = valorSeleccionado;
        if (seleccionesModificadas[idCaracteristica] === undefined) {
          seleccionesModificadas[idCaracteristica] = {};
        }
        if (multiselect) {
          if (seleccionesModificadas[idCaracteristica][valor] !== undefined) {
            delete seleccionesModificadas[idCaracteristica][valor];
          } else {
            seleccionesModificadas[idCaracteristica][valor] = valorSeleccionado;
          }
        } else {
          seleccionesModificadas[idCaracteristica] = {};
          seleccionesModificadas[idCaracteristica] = valorSeleccionado;
        }
      } else {
        seleccionesModificadas[idCaracteristica] = undefined;
      }

      const {
        focos: focosSeleccionados,
        categorias: categoriasSeleccionadas,
        colores: coloresSeleccionados,
      } = seleccionesModificadas;

      let focoSeleccionadoId;
      let categoriaSeleccionadaId;
      let colorSeleccionadoId;

      if (focosSeleccionados) {
        focoSeleccionadoId = focosSeleccionados.id;
      }
      if (categoriasSeleccionadas) {
        categoriaSeleccionadaId = categoriasSeleccionadas.id;
      }
      if (coloresSeleccionados) {
        colorSeleccionadoId = coloresSeleccionados.id;
      }

      let siguientePaso;
      let inputFocused = null;
      const verDatosMontura = permisos?.configuracion?.micatalogo_verdatosmontura === 'T';
      switch (idCaracteristica) {
        case 'focos': {
          seleccionesModificadas.categorias = undefined;
          seleccionesModificadas.colores = undefined;
          seleccionesModificadas.grosores = undefined;
          formularioModificado.categorias.disabled = true;
          formularioModificado.colores.disabled = true;
          formularioModificado.grosores.disabled = true;

          const { opciones } = caracteristica;
          const esMiCa = (puedeElegirCatalogo && catalogo !== undefined && catalogo !== null && catalogo.id !== 1) || (!puedeElegirCatalogo && usaMiCatalogo);
          formularioModificado.focos.opciones = opciones;
          if (!esMiCa) {
            if (viene_de === 'presupuesto') {
              formularioModificado.grosores.disabled = false;
              siguientePaso = 'grosores';
              // Habilitamos los grosores
              if (focosSeleccionados) {
                const keyArray = {};
                formularioModificado.grosores.opciones = grosoresMisCatalogos.filter((grosor) => {
                  const {
                    clasificacion_foco_id: clasificacionFocoIdGrosor,
                    nombre: nombreGrosor,
                    esMiCatalogo,
                  } = grosor;
                  let isUnique = false;
                  const valorValido = (esMiCatalogo == esMiCa) && (clasificacionFocoIdGrosor === focoSeleccionadoId) && (nombreGrosor !== null);
                  if (keyArray[grosor.nombre] === undefined && valorValido) {
                    keyArray[grosor.nombre] = grosor;
                    isUnique = true;
                  }
                  return valorValido && isUnique;
                });
                siguientePaso = viene_de !== 'encargo' ? 'grosores' : 'montura';
              }
            } else {
              siguientePaso = 'montura';
            }
            if (seleccionesModificadas.focos !== null) {
              const esFocoLejos = seleccionesModificadas.focos.valor === 1;
              const esFocoCerca = seleccionesModificadas.focos.valor === 0;
              const esFocoIntermedio = seleccionesModificadas.focos.valor === 2;  
              if(esFocoCerca){
                seleccionesModificadas.focos.modo = CERCA;
              } else if(esFocoIntermedio){
                seleccionesModificadas.focos.modo = INTERMEDIO;
              } else if(esFocoLejos) {
                seleccionesModificadas.focos.modo = LEJOS; 
              } else {
                seleccionesModificadas.focos.modo = LEJOS; 
              }
            }
          } else if (focosSeleccionados && categoriasMisCatalogos) {
            const categoriasParaEsteFoco = categoriasMisCatalogos.filter(({ clasificacion_foco_id: clasificacionFocoId }) => clasificacionFocoId === focoSeleccionadoId);
            const noHayCategoriasParaEsteFoco = categoriasParaEsteFoco.length === 0;
            const soloTieneUnaCategoria = categoriasParaEsteFoco.length === 1;
            if (noHayCategoriasParaEsteFoco) {
              formularioModificado.categorias.opciones = [];
              formularioModificado.colores.disabled = false;
              formularioModificado.colores.opciones = coloresMisCatalogos.filter((color) => {
                const { clasificacion_foco_id: clasificacionFocoId, valor: valorId } = color;
                const cumpleFoco = clasificacionFocoId === focoSeleccionadoId;
                return cumpleFoco;
              });
              siguientePaso = 'colores';
            } else if (soloTieneUnaCategoria) {
              formularioModificado.categorias.opciones = categoriasParaEsteFoco;
              seleccionesModificadas.categorias = categoriasParaEsteFoco[0];
              formularioModificado.colores.disabled = false;
              formularioModificado.colores.opciones = coloresMisCatalogos.filter((color) => {
                const { clasificacion_foco_id: clasificacionFocoId, categoria_id: categoriaIdColor } = color;
                const cumpleFoco = clasificacionFocoId === focoSeleccionadoId;
                let cumpleCategoria = true;
                if (categoriasParaEsteFoco[0].id !== undefined) {
                  cumpleCategoria = categoriasParaEsteFoco[0].id === categoriaIdColor;
                }
                return cumpleFoco && cumpleCategoria;
              });
              siguientePaso = 'colores';
            } else {
              formularioModificado.categorias.opciones = categoriasParaEsteFoco;
              formularioModificado.categorias.disabled = false;
              formulario.colores.opciones = [];
              siguientePaso = 'categorias';
            }
            if (seleccionesModificadas.focos !== null) {
              let modo = LEJOS;
              switch(seleccionesModificadas.focos.valor) {
                case 0:
                  modo = CERCA;
                break;
                case 1:
                case 3:
                case 4:
                  modo = LEJOS;
                break;
                case 2:
                  modo = INTERMEDIO;
                break;
              }
              seleccionesModificadas.focos.modo = modo
            }
          }

          break;
        }
        case 'categorias': {
          seleccionesModificadas.colores = undefined;
          seleccionesModificadas.grosores = undefined;
          formularioModificado.colores.disabled = true;
          formularioModificado.grosores.disabled = true;
          if (viene_de === 'presupuesto') {
            formularioModificado.tratamientos.opciones = tratamientosMiCatalogo;
            formularioModificado.tratamientos.disabled = false;
          } else if (focosSeleccionados && coloresMisCatalogos) {
            formularioModificado.colores.opciones = coloresMisCatalogos.filter((color) => {
              const { clasificacion_foco_id: focoIdColor, categoria_id: categoriaIdColor } = color;
              const cumpleFoco = focoIdColor === focoSeleccionadoId;
              let cumpleCategoria = true;
              if (categoriaSeleccionadaId !== undefined) {
                cumpleCategoria = categoriaSeleccionadaId === categoriaIdColor;
              }
              return cumpleFoco && cumpleCategoria;
            });
            formularioModificado.colores.disabled = false;
          }
          siguientePaso = viene_de === 'presupuesto' ? 'tratamientos' : 'colores';
          break;
        }
        case 'tratamientos': {
          if (focosSeleccionados && coloresMisCatalogos) {
            formularioModificado.colores.opciones = coloresMisCatalogos.filter((color) => {
              const { clasificacion_foco_id: focoIdColor, categoria_id: categoriaIdColor } = color;
              const cumpleFoco = focoIdColor === focoSeleccionadoId;
              let cumpleCategoria = true;
              if (categoriaSeleccionadaId !== undefined) {
                cumpleCategoria = categoriaSeleccionadaId === categoriaIdColor;
              }
              return cumpleFoco && cumpleCategoria;
            });
            formularioModificado.colores.disabled = false;
            siguientePaso = 'colores';
          }
          break;
        }
        case 'colores': {
          seleccionesModificadas.grosores = undefined;
          if (focosSeleccionados && coloresSeleccionados) {
            const hayCategoriasParaEsteFoco = formularioModificado.categorias.opciones.length !== 0;
            const esMiCa = (catalogo !== undefined && catalogo !== null && catalogo.id !== 0) ? 0 : 1;
            formularioModificado.grosores.opciones = grosoresMisCatalogos.filter((grosor) => {
              const {
                clasificacion_foco_id: clasificacionFocoIdGrosor,
                categoria_id: categoriaIdGrosor,
                color_id: colorIdGrosor,
                esMiCatalogo,
              } = grosor;
              let cumpleCategoria = true;
              if (hayCategoriasParaEsteFoco) {
                cumpleCategoria = (categoriaIdGrosor === categoriaSeleccionadaId);
              }
              return (esMiCatalogo === esMiCa) && (clasificacionFocoIdGrosor === focoSeleccionadoId) && (colorIdGrosor === colorSeleccionadoId) && cumpleCategoria;
            });
            formularioModificado.grosores.disabled = false;
            siguientePaso = viene_de !== 'encargo' ? 'grosores' : 'montura';
          }
          break;
        }
        case 'grosores': {
          const { grosores } = seleccionesModificadas;
          const grosoresKeys = Object.keys(grosores);
          for (let i = 0; i < grosoresKeys.length; i += 1) {
            grosores[grosoresKeys[i]].isSelected = true;
          }
          siguientePaso = 'montura';
          break;
        }
        case 'graduacion': {
          if (focoSeleccionadoId === undefined && (catalogo === undefined || catalogo === null || catalogo.id !== 1)) {
            siguientePaso = puedeElegirCatalogo ? 'catalogo' : 'focos';
            if (!puedeElegirCatalogo) formularioModificado.focos.disabled = false;
          } else {
            siguientePaso = 'montura';
            const { graduacion: { derecho: { DNPL } } } = seleccionesModificadas;
            if (DNPL > 10) {
              inputFocused = 'tipoMontura';
            }
          }
          break;
        }
        case 'catalogo': {
          const esMiCa = (puedeElegirCatalogo && (valorSeleccionado !== undefined && valorSeleccionado !== null && valorSeleccionado.id !== 1)) || (!puedeElegirCatalogo && usaMiCatalogo);
          const { graduacion: graduacionSeleccionada } = seleccionesModificadas;
          const { derecho: { ADD: ADD_D }, izquierdo: { ADD: ADD_I } } = graduacionSeleccionada;
          seleccionesModificadas.focos = null;
          focoSeleccionadoId = null;
          if (esMiCa) {
            siguientePaso = 'focos';
            formularioModificado.focos.disabled = false;
          } else {
            siguientePaso = 'focos';
            formularioModificado.focos.disabled = false;
            formularioModificado.grosores.disabled = viene_de !== 'presupuesto';
            formularioModificado.tratamientos.disabled = true;
            formularioModificado.categorias.disabled = true;
            formularioModificado.colores.disabled = true;
            const { graduacion: { derecho: { DNPL } } } = seleccionesModificadas;
            if (DNPL > 10) {
              inputFocused = 'tipoMontura';
            }
          }
          break;
        }
        case 'montura': {
          const esMiCa = (catalogo !== undefined && catalogo !== null && catalogo.id !== 1) || (usaMiCatalogo && (!tienePromocion || (tienePromocion && paraLentesGenericas)));

          const { montura: monturaSeleccionada, graduacion } = seleccionesModificadas;
          if (!verDatosMontura) {
            monturaSeleccionada.diametroMinimo = 1;
          } else if (monturaSeleccionada.diametroMinimo) {
            monturaSeleccionada.diametroMinimo = Math.ceil(monturaSeleccionada.diametroMinimo / 5) * 5;
          }
          if (puedeElegirCatalogo && (catalogo === undefined || catalogo === null)) {
            siguientePaso = 'catalogo';
          } else if (focoSeleccionadoId === undefined) {
            siguientePaso = 'focos';
          } else {
            siguientePaso = 'montura';
            const { montura: monturaSeleccionada, graduacion } = seleccionesModificadas;
            const {
              calibre, puente, tipoMontura,
            } = monturaSeleccionada;
            if (calibre > 10) {
              if (puente > 10) {
                inputFocused = 'dnp';
              } else {
                inputFocused = 'puente';
              }
            }
            if (calibre !== null && puente !== null && verDatosMontura) {
              let pupilarD = null;
              let pupilarL = null;
              let diametroMinimoL = null;
              let diametroMinimoD = null;
              let diametroMinimo = null;
              if (graduacion.izquierdo.DNPL !== null) {
                pupilarL = graduacion.izquierdo.DNPL;
                diametroMinimoL = (tipoMontura === 1)
                  ? (2 * (parseFloat(calibre) - parseFloat(pupilarL) + 3) + parseFloat(puente))
                  : (2 * (parseFloat(calibre) - parseFloat(pupilarL) + 1.5) + parseFloat(puente));
              }
              if (graduacion.derecho.DNPL !== null) {
                pupilarD = graduacion.derecho.DNPL;
                diametroMinimoD = (tipoMontura === 1)
                  ? (2 * (parseFloat(calibre) - parseFloat(pupilarD) + 3) + parseFloat(puente))
                  : (2 * (parseFloat(calibre) - parseFloat(pupilarD) + 1.5) + parseFloat(puente));
              }
              if (graduacion.izquierdo.DNPL !== null) {
                if (graduacion.derecho.DNPL !== null) {
                  diametroMinimo = (diametroMinimoD >= diametroMinimoL) ? diametroMinimoD : diametroMinimoL;
                } else {
                  diametroMinimo = diametroMinimoL;
                }
              } else if (graduacion.derecho.DNPL !== null) {
                diametroMinimo = diametroMinimoD;
              }
              if (diametroMinimo !== null) {
                seleccionesModificadas.montura.diametroMinimo = Math.ceil(diametroMinimo / 5) * 5;
              }
            }
          }
          break;
        }
        default: {
          const esMiCa = (catalogo !== undefined && catalogo !== null && catalogo.id !== 1) || (usaMiCatalogo && (!tienePromocion || (tienePromocion && paraLentesGenericas)));
          if (esMiCa) siguientePaso = 'focos';
          if (!esMiCa) siguientePaso = 'montura';
          break;
        }
      }
      if (seleccionesModificadas.graduacion.valor !== null) {
        let mostrarGraduacionDerecha = false;
        let mostrarGraduacionIzquierda = false;
        const {
          ESFC: ESFCD, CILC: CILCD, AXISC: AXISCD, ESFL: ESFLD, CILL: CILLD, AXISL: AXISLD,
        } = seleccionesModificadas.graduacion.derecho;
        const {
          ESFC: ESFCI, CILC: CILCI, AXISC: AXISCI, ESFL: ESFLI, CILL: CILLI, AXISL: AXISLI,
        } = seleccionesModificadas.graduacion.izquierdo;
        if (ESFCD || CILCD || AXISCD || ESFLD || CILLD || AXISLD) {
          mostrarGraduacionDerecha = true;
        }
        if (ESFCI || CILCI || AXISCI || ESFLI || CILLI || AXISLI) {
          mostrarGraduacionIzquierda = true;
        }

        seleccionesModificadas.graduacion.derecho.isSelected = mostrarGraduacionDerecha;
        seleccionesModificadas.graduacion.izquierdo.isSelected = mostrarGraduacionIzquierda;
      }
      seleccionesModificadas.graduacion.generico = { ...initialState.filtrador.selecciones.graduacion.generico };
      const hayColorSeleccionado = (colorSeleccionadoId !== undefined && colorSeleccionadoId !== null);
      const hayFocoSeleccionado = (focoSeleccionadoId !== undefined && focoSeleccionadoId !== null);
      const { montura: { puente, calibre, tipoMontura }, graduacion: { derecho: { DNPL } } } = seleccionesModificadas;
      const parametrosMonturaEsablecidos = puente !== null && puente !== '' && calibre !== null && calibre !== '' && tipoMontura !== null && tipoMontura !== '' && calibre !== undefined;
      const parametrosGraduacionEstablecidos = DNPL !== null && DNPL !== '';
      // const busquedaValida = hayColorSeleccionado && parametrosMonturaEsablecidos && parametrosGraduacionEstablecidos;
      const modoNoPel = (catalogo && catalogo.id !== 0 && modo !== 'consulta') || (!usaMiCatalogo && (!tienePromocion || (tienePromocion && !paraLentesGenericas)));
      const esMiCa = (catalogo !== undefined && catalogo !== null && catalogo.id !== 1);
      const faltanDatosMontura = permisos && permisos.configuracion.micatalogo_verdatosmontura === 'T' && permisos.configuracion.micatalogo_obligarmontura === 'T' && !parametrosMonturaEsablecidos;
      const botonBusquedaEnabled = ((hayColorSeleccionado || !esMiCa) && (parametrosGraduacionEstablecidos || !verDatosMontura) && hayFocoSeleccionado);
      const busquedaValida = !faltanDatosMontura && botonBusquedaEnabled;
      const filtradorModificado = {
        ...filtrador,
        busquedaValida,
        faltanDatosMontura,
        botonBusquedaEnabled,
        inputFocused,
        panelActivo: siguientePaso,
        selecciones: seleccionesModificadas,
        formulario: formularioModificado,
        parametrosMonturaEsablecidos,
      };
      return {
        ...state,
        modoNoPel,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_MIS_CATALOGOS_MODIFICAR: {
      return {
        ...state,
        misCatalogos: payload,
        inicializado: true,
      };
    }
    case LENTES_PEL_CAMBIAR_PANEL_ACTIVO: {
      const { panelActivo } = payload;
      const { filtrador } = state;
      return {
        ...state,
        filtrador: {
          ...filtrador,
          panelActivo,
        },
      };
    }
    case LENTES_PEL_RESTABLECER_FILTRO: {
      const { filtrador } = initialState;
      return {
        ...state,
        filtrador,
      };
    }
    case LENTES_PEL_FORMULARIO_FILTRO_ESTABLECER_OPCIONES_PANEL: {
      const { panel, opciones } = payload;
      const { filtrador } = state;
      const { formulario, selecciones: { graduacion: { derecho: { ADD: ADD_D, ESFC: ESFC_D, ESFL: ESFL_D, ESFI: ESFI_D }, izquierdo: { ADD: ADD_I, ESFC: ESFC_I, ESFL: ESFL_I, ESFI: ESFI_I } } } } = filtrador;
      const formularioModificado = {
        ...formulario,
      };
      if (panel && formularioModificado[panel]) {
        let opcionesFiltradas = opciones;
        if (panel === 'focos') {
          const noTieneAdiccion = (Number.isNaN(parseFloat(ADD_D)) || parseFloat(ADD_D) === 0) && (Number.isNaN(parseFloat(ADD_I)) || parseFloat(ADD_I) === 0);
          const noTieneEsferaCerca = (Number.isNaN(parseFloat(ESFC_D))) && (Number.isNaN(parseFloat(ESFC_I)));
          const noTieneEsferaLejos = (Number.isNaN(parseFloat(ESFL_D))) && (Number.isNaN(parseFloat(ESFL_I)));
          const noTieneEsferaIntermedia = (Number.isNaN(parseFloat(ESFI_D))) && (Number.isNaN(parseFloat(ESFI_I)));

          if(!noTieneAdiccion){
            if(noTieneEsferaIntermedia){
              opcionesFiltradas = opcionesFiltradas.filter(({ valor: valorFoco }) => valorFoco !== 2);
            }
          }else{
            opcionesFiltradas = opcionesFiltradas.filter(({ valor: valorFoco }) => valorFoco !== 3 && valorFoco !== 4);
            if(noTieneEsferaCerca){
              opcionesFiltradas = opcionesFiltradas.filter(({ valor: valorFoco }) => valorFoco !== 0);
            }
            if(noTieneEsferaLejos){
              opcionesFiltradas = opcionesFiltradas.filter(({ valor: valorFoco }) => valorFoco !== 1);
            }
            if(noTieneEsferaIntermedia){
              opcionesFiltradas = opcionesFiltradas.filter(({ valor: valorFoco }) => valorFoco !== 2);
            }
          }
        }
        formularioModificado[panel].opciones = opcionesFiltradas;
      }
      const filtradorModificado = {
        ...filtrador,
        formulario: formularioModificado,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_INDICE: {
      const { indiceId, isSelected } = payload;
      const { filtrador, viene_de } = state;
      const { selecciones } = filtrador;
      const { indices, grosores } = selecciones;

      const indicesCpy = [...indices];
      const grosoresModificados = { ...grosores };
      const indicesModificados = indicesCpy.map((indice) => {
        let selected = (viene_de === 'presupuesto') ? false : indice.isSelected;
        selected = (indice.id === indiceId) ? isSelected : selected;
        if (grosoresModificados[indice.id]) { grosoresModificados[indice.id].isSelected = selected; }
        return { ...indice, isSelected: selected };
      });
      const seleccionesModificadas = {
        ...selecciones,
        indices: indicesModificados,
        grosores: grosoresModificados,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificadas,
      };

      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_COLOR: {
      const { colorId } = payload;
      const { filtrador } = state;
      const { buscador, selecciones } = filtrador;
      const { misColores } = buscador;
      const color = misColores.find(e => colorId === e.id);

      const seleccionesModificadas = {
        ...selecciones,
        miColor: color,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificadas,
      };

      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_GRADUACION: {
      const { derecho, izquierdo } = payload;
      const { filtrador } = state;
      const { selecciones } = filtrador;
      const { graduacion } = selecciones;
      const graduacionesModificadas = { ...graduacion };
      if (derecho) {
        graduacionesModificadas.derecho = { ...graduacion.derecho, isSelected: !graduacion.derecho.isSelected };
      } else if (izquierdo) {
        graduacionesModificadas.izquierdo = { ...graduacion.izquierdo, isSelected: !graduacion.izquierdo.isSelected };
      }
      const seleccionesModificadas = {
        ...selecciones,
        graduacion: graduacionesModificadas,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificadas,
      };

      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_GRADUACION_GENERICA: {
      const { valor, tipo } = payload;
      const { filtrador } = state;
      const { selecciones } = filtrador;
      const { graduacion, colores } = selecciones;
      const { generico } = graduacion;
      const graduacionGenericaModificada = { ...generico };
      const value = valor === null || valor === undefined ? '' : valor;
      switch (tipo) {
        case 'adicion': {
          graduacionGenericaModificada.ADD = value;
          break;
        }
        case 'eje': {
          graduacionGenericaModificada.AXIS = value;
          break;
        }
        case 'esfera': {
          graduacionGenericaModificada.ESF = value;
          break;
        }
        case 'cilindro': {
          graduacionGenericaModificada.CIL = value;
          break;
        }
      }
      const graduacionesModificadas = { ...graduacion, generico: graduacionGenericaModificada };
      const seleccionesModificadas = {
        ...selecciones,
        graduacion: graduacionesModificadas,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificadas,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_FABRICANTE: {
      const { fabricanteId } = payload;
      const { filtrador } = state;
      const { buscador, selecciones } = filtrador;
      const { misFabricantes, misColores } = buscador;
      const fabricante = misFabricantes.find(e => fabricanteId === e.id);
      const color = misColores.find(e => e.gamaColor === 1);
      // const usaMiCatalogo = fabricante.id === -1;
      const modoNoPel = fabricante.id !== -1;
      const seleccionesModificadas = {
        ...selecciones,
        miColor: color || null,
        miFabricante: fabricante,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificadas,
      };

      return {
        ...state,
        modoNoPel,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_LENTE_TIPO_PVP: {
      const { lenteTipoPvpId } = payload;
      const { filtrador } = state;
      const { buscador, selecciones } = filtrador;
      const { lentesTiposPvps } = buscador;
      const lenteTipoPvp = lentesTiposPvps.find(e => lenteTipoPvpId === e.id);

      const seleccionesModificadas = {
        ...selecciones,
        lenteTipoPvp,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificadas,
      };

      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_COLORES_SUCCESS: {
      const { misColores, modo, trabajaConColores } = payload;
      const { filtrador, modoNoPel } = state;
      const { buscador, selecciones, formulario } = filtrador;
      const seleccionesModificadas = { ...selecciones };
      const formularioModificado = { ...formulario };
      const misColoresDef = (modo === 'consulta') ? misColores.misColores : misColores;
      const lentesGamasColor = (modo === 'consulta') ? misColores.lentesGamasColor : [];
      if (modo === 'consulta')formularioModificado.colores.opciones = lentesGamasColor;
      if ((selecciones.colores && selecciones.colores.tipo_id === 1 && misColoresDef.length > 0) || modo === 'consulta') {
        seleccionesModificadas.miColor = (misColoresDef[0]);
      } else if (!modoNoPel && !trabajaConColores) {
        seleccionesModificadas.miColor = misColoresDef.find(e => e.nombre === 'Ninguno');
      } else {
        seleccionesModificadas.miColor = null;
      }
      const buscadorModificado = {
        ...buscador,
        misColores: misColoresDef,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificadas,
        buscador: buscadorModificado,
        formulario: formularioModificado,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_FABRICANTES_SUCCESS: {
      const misFabricantes = payload;
      const { filtrador, usaMiCatalogo, modo } = state;
      const { buscador, selecciones: { catalogo } } = filtrador;
      const modoNoPel = (catalogo !== undefined && catalogo !== null && catalogo.id !== 0 && modo !== 'consulta') || !usaMiCatalogo;
      const misFabricantesFull = !modoNoPel ? [
        {
          id: -1,
          proveedor: 'Mi Catalogo',
          activa: 1,
        }] : [];
      const buscadorModificado = {
        ...buscador,
        misFabricantes: misFabricantesFull.concat(misFabricantes),
      };
      const filtradorModificado = {
        ...filtrador,
        buscador: buscadorModificado,
      };
      return {
        ...state,
        modoNoPel,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_LENTESTIPOSPVP_SUCCESS: {
      const lentesTiposPvps = payload;
      const { filtrador, numPack, tienePromocion } = state;
      const { buscador, selecciones } = filtrador;
      const seleccionModificada = {
        ...selecciones,
      };
      if (tienePromocion && numPack !== undefined && numPack !== null) {
        const searchId = numPack === -1 ? 0 : numPack + 1;
        seleccionModificada.lenteTipoPvp = lentesTiposPvps.find(e => e.posicion === searchId);
      } else {
        seleccionModificada.lenteTipoPvp = lentesTiposPvps.find(e => e.posicion === 0);
      }

      const buscadorModificado = {
        ...buscador,
        lentesTiposPvps,
      };
      const filtradorModificado = {
        ...filtrador,
        buscador: buscadorModificado,
        selecciones: seleccionModificada,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_PASILLO: {
      const pasilloId = payload;
      const { filtrador } = state;
      const { selecciones } = filtrador;
      const { pasillos } = selecciones;

      let pasillosModificados = [...pasillos];
      pasillosModificados = pasillosModificados.map((e) => {
        e.isSelected = (e.id === pasilloId);
        return e;
      });
      const seleccionesModificado = {
        ...selecciones,
        pasillos: pasillosModificados,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificado,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_DIAMETROS_POSIBLES_SUCCESS: {
      const { diametros, lente } = payload;
      const { filtrador } = state;
      const lentesModificadas = { ...filtrador.lentes };
      if (diametros !== null) {
        lentesModificadas[lente.key].diametros = diametros;
      }
      const filtradorModificado = {
        ...filtrador,
        lentes: lentesModificadas,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_SUCCESS: {
      const { tratamientos, lente } = payload;
      const { filtrador } = state;
      const lentesModificadas = { ...filtrador.lentes };
      const tratbase = lentesModificadas[lente.key].tratamientos.find(e => e.isSelected);
      if (tratamientos !== null && tratamientos.length > 0) {
        const precio_oi = tratbase.precio_oi ? tratbase.precio_oi : tratbase.precio;
        lentesModificadas[lente.key].tratamientos = tratamientos.map(({
          id, nombre, costoTratamiento, precioTratamiento,
        }) => ({
          ...tratbase,
          id,
          nombre,
          costoTratamiento,
          precioTratamiento,
          isSelected: tratbase.id === id,
          precio: tratbase.precio - tratbase.precioTratamiento + precioTratamiento,
          precio_oi: precio_oi - tratbase.precioTratamiento + precioTratamiento,
          costo: tratbase.costo - tratbase.costoTratamiento + costoTratamiento,
        }));
      }
      const filtradorModificado = {
        ...filtrador,
        lentes: lentesModificadas,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_COLORES_LENTE_SUCCESS: {
      const { colores, lente } = payload;
      const { filtrador } = state;
      const lentesModificadas = { ...filtrador.lentes };
      lentesModificadas[lente.key].colores = colores;
      const filtradorModificado = {
        ...filtrador,
        lentes: lentesModificadas,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_TRATAMIENTO_LENTE: {
      const { lenteKey, tratamientoId } = payload;
      const { filtrador, modoNoPel } = state;
      const { lentes } = filtrador;

      const lente = lentes[lenteKey];
      const tratamientosModificados = [...lente.tratamientos];
      const antiguoTratamientoIndex = tratamientosModificados.findIndex(e => e.isSelected);
      const tratamientoIndex = tratamientosModificados.findIndex(e => e.id === tratamientoId);
      tratamientosModificados[tratamientoIndex].isSelected = true;
      if (antiguoTratamientoIndex !== -1 && tratamientoIndex !== antiguoTratamientoIndex) {
        tratamientosModificados[antiguoTratamientoIndex].isSelected = false;
      }
      const lenteModificada = { ...lente, tratamientos: tratamientosModificados };
      lenteModificada.diametrosSeleccionados = { I: tratamientosModificados[tratamientoIndex].diametros.I[0], D: tratamientosModificados[tratamientoIndex].diametros.D[0] };
      const lentesModificadas = { ...lentes, [lenteKey]: lenteModificada };
      const filtradorModificado = {
        ...filtrador,
        lentes: lentesModificadas,
      };

      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_LENTE: {
      const lenteKey = payload;
      const { filtrador } = state;
      const { lentes } = filtrador;
      const lentesModificadas = { ...lentes };
      const lentesKeys = Object.keys(lentes);

      for (let i = 0; i < lentesKeys.length; i += 1) {
        lentesModificadas[lentesKeys[i]].isSelected = (lentesKeys[i] === lenteKey);
      }
      const filtradorModificado = {
        ...filtrador,
        lentes: lentesModificadas,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_PASILLOS_SUCCESS: {
      const pasillos = payload;
      const { filtrador } = state;
      const { selecciones } = filtrador;
      const { focos } = selecciones;

      const pasillosModificados = pasillos.map(pasillo => ({ ...pasillo, isSelected: false }));
      if (focos && focos.id === 2) {
        pasillosModificados[1].isSelected = true;
      } else {
        pasillosModificados[0].isSelected = true;
      }
      const seleccionesModificado = {
        ...selecciones,
        pasillos: pasillosModificados,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificado,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_INDICES_SUCCESS: {
      const indices = payload;
      const { filtrador, viene_de } = state;
      const { selecciones } = filtrador;
      const { grosores } = selecciones;

      const indicesModificados = indices.map((indice) => {
        // const isSelected = (grosores[indice.id.toString()] !== undefined);
        const grosorPrevioSeleccionado = grosores !== undefined && grosores[indice.id.toString()] !== undefined && grosores[indice.id.toString()].isSelected;
        const isSelected = (!viene_de || viene_de !== 'presupuesto') ? true : grosorPrevioSeleccionado;
        return { ...indice, isSelected };
      });
      indicesModificados.push({
        activa: true,
        id: -1,
        nombre: 'Otros',
        oculta: false,
        valor: -1,
        esMiCatalogo: 0,
      });
      indicesModificados.push({
        activa: true,
        id: -1,
        nombre: 'Otros',
        oculta: false,
        valor: -1,
        esMiCatalogo: 1,
      });
      const seleccionesModificado = {
        ...selecciones,
        indices: indicesModificados,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificado,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SET_DIAMETRO_MINIMO: {
      const diametroMinimo = Math.ceil(parseFloat(payload));
      const { filtrador } = state;
      const { selecciones } = filtrador;
      const { montura } = selecciones;

      const seleccionesModificado = {
        ...selecciones,
        montura: { ...montura, diametroMinimo },
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificado,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_LENTES_LIST_SUCCESS: {
      const lentesKeys = (!payload) ? [] : Object.keys(payload);
      const lentes = (!payload || lentesKeys.length === 0) ? {} : payload;
      const { filtrador } = state;
      for (let i = 0; i < lentesKeys.length; i++) {
        lentes[lentesKeys[i]].isSelected = false;
      }
      const filtradorModificado = {
        ...filtrador,
        lentes: { ...filtrador.lentes, ...lentes },
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SET_INICIALIZADO: {
      return {
        ...state,
        inicializado: payload,
        filtrador: { ...state.filtrador, lentes: {}, datosLenteSeleccionada: {} },
        usaMiCatalogo: state.usaMiCatalogo,
      };
    }
    case LENTES_PEL_SET_FUERA_NORMA: {
      return {
        ...state,
        filtrador: { ...state.filtrador, fueraDeNorma: payload },
      };
    }
    case LENTES_PEL_CLEAR_TOOLBAR_DATA: {
      const { filtrador } = state;
      return {
        ...state,
        filtrador: {
          ...filtrador,
          barraBusqueda: initialState.filtrador.barraBusqueda,
        },
      };
    }
    case LENTES_PEL_SET_SEARCH_VALUE: {
      const { filtrador } = state;
      const { lentes } = filtrador;
      const lentesModificadas = { ...lentes };
      const lentesKeys = Object.keys(lentes);

      for (let i = 0; i < lentesKeys.length; i += 1) {
        lentesModificadas[lentesKeys[i]].isSelected = false;
      }
      const filtradorModificado = {
        ...filtrador,
        lentes: lentesModificadas,
        barraBusqueda: { value: payload },
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_GET_ORDEN_GRADUACION_SUCCESS: {
      const ordenGraduacion = payload;
      const { filtrador } = state;
      const { selecciones } = filtrador;

      const seleccionesModificadas = {
        ...selecciones,
        ordenGraduacion,
      };
      const filtradorModificado = {
        ...filtrador,
        selecciones: seleccionesModificadas,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_COLOR_INTENSIDAD: {
      const { lenteKey, colorIntensidadId } = payload;
      const { filtrador } = state;
      const { lentes } = filtrador;

      const lente = lentes[lenteKey];
      let coloresIntensidadesModificados = [...lente.colores];
      coloresIntensidadesModificados = coloresIntensidadesModificados.map(c => ({ ...c, isSelected: c.id === colorIntensidadId }));
      const lenteModificada = { ...lente, colores: coloresIntensidadesModificados };
      const lentesModificadas = { ...lentes, [lenteKey]: lenteModificada };
      const filtradorModificado = {
        ...filtrador,
        lentes: lentesModificadas,
      };

      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SELECCION_DIAMETRO: {
      const { ojo, lenteKey, diametro } = payload;
      const { filtrador } = state;
      const { lentes } = filtrador;
      const lente = lentes[lenteKey];
      const diametrosSeleccionadosModificados = { ...lente.diametrosSeleccionados };
      if (ojo === 'D') {
        diametrosSeleccionadosModificados.D = diametro;
      } else if (ojo === 'I') {
        diametrosSeleccionadosModificados.I = diametro;
      } else {
        diametrosSeleccionadosModificados.D = diametro;
        diametrosSeleccionadosModificados.I = diametro;
      }
      const lenteModificada = { ...lente, diametrosSeleccionados: diametrosSeleccionadosModificados };
      const lentesModificadas = { ...lentes, [lenteKey]: lenteModificada };
      const filtradorModificado = {
        ...filtrador,
        lentes: lentesModificadas,
      };

      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SET_ALTURA_FOCAL: {
      const { ojo, lenteKey, altura } = payload;
      const { filtrador } = state;
      const { lentes } = filtrador;
      const lente = lentes[lenteKey];
      const alturasFocalesModificadas = { ...lente.alturaFocal };
      const alturaAGuardar = altura === '' ? undefined : altura;
      if (ojo === 'D') {
        alturasFocalesModificadas.D = alturaAGuardar;
      } else if (ojo === 'I') {
        alturasFocalesModificadas.I = alturaAGuardar;
      } else {
        alturasFocalesModificadas.D = alturaAGuardar;
        alturasFocalesModificadas.I = alturaAGuardar;
      }
      const lenteModificada = { ...lente, alturaFocal: alturasFocalesModificadas };
      const lentesModificadas = { ...lentes, [lenteKey]: lenteModificada };
      const filtradorModificado = {
        ...filtrador,
        lentes: lentesModificadas,
      };

      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_SET_FINAL_SELECTION: {
      const { filtrador } = state;
      const filtradorModificado = {
        ...filtrador,
        datosLenteSeleccionada: payload,
      };

      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case LENTES_PEL_ESTABLECER_DNP_OBLIGATORIO: {
      return {
        ...state,
        dnpObligatorio: payload,
      };
    }
    case CLEAR_LENTES_LIST_ACTION: {
      const { filtrador } = state;
      const filtradorModificado = {
        ...filtrador,
        pagina: 1,
        lentes: { },
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    case NEXT_PAGE_LENTES_LIST: {
      const { filtrador } = state;
      const filtradorModificado = {
        ...filtrador,
        pagina: filtrador.pagina + 1,
      };
      return {
        ...state,
        filtrador: filtradorModificado,
      };
    }
    default: {
      return state;
    }
  }
}
